<div
  *ngIf="tableRows"
  class="table-wrap"
  [ngClass]="{ 'table-with-forecast': isForecastEnabled }"
  scrollOnDrag
  tableContentShadows
  [updateShadows$]="updateShadows$"
  (onShadowChanged)="handleShadowUpdate($event)"
>
  <table elementResizeObserver (onElementResize)="handleTableResize()">
    <thead>
    <tr>
      <th></th>
      <th *ngFor="let column of tableColumns">
        <div class="label">
          <span *ngFor="let labelPart of column.label">
            <ng-container *ngIf="labelPart.toLowerCase() === 'forecast'">
              <img src="../../../../assets/images/icon-forecast.svg" alt="Forecast" class="forecast-icon">
            </ng-container>
            {{ labelPart }}
          </span>
        </div>
      </th>
    </tr>
    <tr class="shadow-tr">
      <td [colSpan]="tableColumns.length + 1"></td>
    </tr>
    </thead>
    <tbody>
      <ng-container  *ngFor="let row of tableRows; let rowIndex = index" >
    <tr [ngClass]="{ 'locked': row.locked }">
      <th [ngClass]="{'program-name-cell': objectType === 'Program'}">
        <span class="name-cell">
          {{ row.shortName }}
          <fa-icon [icon]="['fas', 'lock-keyhole']" *ngIf="row.locked" class="lock-icon"></fa-icon>
        </span>
      </th>
      <td *ngFor="let column of tableColumns; let columnIndex = index"
      (click)="highlightCell(rowIndex, columnIndex, row, column)"
            [ngClass]="{ 'selected': selectedCell && selectedCell.row === rowIndex && selectedCell.column === columnIndex, 'clickable' : column.id !== manageTableBudgetColumnName.Budget && column.id !== manageTableBudgetColumnName.Forecast && row.values[column.id] && objectType !== 'Program', 'program-allocation-table': objectType === 'Program' }">
        <div
          *ngIf="column.id === manageTableBudgetColumnName.Budget"
          [matTooltip]="segmentlessAllocationTooltip"
          [matTooltipDisabled]="!isSegmentlessCampaign"
          matTooltipClass="dark-theme-tooltip above border-rounded segment-less-allocation"
          matTooltipPosition="above">

          <budget-allocation-cell
            #budgetAllocationCell
            [ngClass]="{'display-inline-table': (allocationTotals[manageTableBudgetColumnName.Budget] < 0)}"

            [allocated]="row.values[manageTableBudgetColumnName.Budget]"
            [spent]="null"
            [remaining]="isBudgetPrimary ? row.values[manageTableBudgetColumnName.Available] : null"
            [hasRemainingBudget]="isBudgetPrimary"

            [disabled]="isCellDisabled(row)"
            [editable]="isCellEditable(row)"
            [showDifference]="isBudgetPrimary"
            [allowGestures]="isBudgetPrimary && !isCellDisabled(row)"
            [droppable]="isBudgetPrimary && !isCellDisabled(row) && !restrictedFromDrop[row.id]"
            [draggable]="isBudgetPrimary"
            (onFocus)="handleOnFocus($event, row)"
            (onChange)="handleAllocationChange($event, row)"
            (onDoubleClick)="isBudgetPrimary ? handleDoubleClick($event, row) : null"
            (onDrop)="isBudgetPrimary ? handleOnDrop($event, row) : null"
            (onDragStart)="isBudgetPrimary ? handleOnDragStart($event, row) : null">
          </budget-allocation-cell>
        </div>


          <div
            *ngIf="column.id === manageTableBudgetColumnName.Forecast"
            [matTooltip]="segmentlessAllocationTooltip"
            [matTooltipDisabled]="!isSegmentlessCampaign"
            matTooltipClass="dark-theme-tooltip above border-rounded segment-less-allocation"
            matTooltipPosition="above">

            <budget-allocation-cell
              [ngClass]="{'display-inline-table': (row.values[manageTableBudgetColumnName.Forecast]<0)}"
              [allocated]="row.values[manageTableBudgetColumnName.Forecast]"
              [spent]="null"
              [remaining]="isForecastPrimary ? row.values[manageTableBudgetColumnName.Available] : null"
              [hasRemainingBudget]="isForecastPrimary"

              [disabled]="isCellDisabled(row)"
              [editable]="isCellEditable(row)"
              [showDifference]="isForecastPrimary"
              [allowGestures]="isForecastPrimary && !isCellDisabled(row)"
              [droppable]="isForecastPrimary && !isCellDisabled(row) && !restrictedFromDrop[row.id]"
              [draggable]="isForecastPrimary"
              (onChange)="handleForecastAmountChange($event, row)"
              (onDoubleClick)="isForecastPrimary ? handleForecastDoubleClick($event, row) : null"
              (onDrop)="isForecastPrimary ? handleOnDrop($event, row) : null"
              (onDragStart)="isForecastPrimary ? handleOnDragStart($event, row) : null">
            </budget-allocation-cell>
          </div>


        <ng-container *ngIf="column.id !== manageTableBudgetColumnName.Budget && column.id !== manageTableBudgetColumnName.Forecast && objectType !== 'Program'">
          <div>{{row.values[column.id]  | absoluteNumber}}</div>
        </ng-container>

        <ng-container *ngIf="column.id !== manageTableBudgetColumnName.Budget && column.id !== manageTableBudgetColumnName.Forecast && objectType === 'Program'">
          <ng-container *ngTemplateOutlet="clickableValue; context: {
          $implicit: row.values[column.id],
          timeframeId: row.timeframeId,
          columnId: column.id
         }"></ng-container>
        </ng-container>

      </td>
    </tr>
    <tr *ngIf="selectedCell && selectedCell.row === rowIndex" class="accordion-cell" [class.expanded]="selectedCell">
      <td  [colSpan]="tableColumns.length + 1" class="accordion-col">
        <div class="accordion-box">

          <div class="loading-area" *ngIf="isLoading">
            <loader [isVisible]="isLoading"></loader>
          </div>

          <ng-container *ngIf="!isLoading">
            <header>
              <span  *ngIf="selectedColumn == manageTableBudgetColumnName.Actual" class="text" (click)="selectedRowValue && onCellClick(selectedRowTimeframe, selectedColumn)">View all on the Expense page</span>
              <span *ngIf="selectedColumn !== manageTableBudgetColumnName.Actual" class="text" (click)="selectedRowValue && onCellClick(selectedRowTimeframe, selectedColumn)">View all {{accData.length}} on the Manage page</span>
              <span class="close-acc" (click)="clearSelection()">Close</span>
            </header>
            <aside [ngClass]="['accordion-content', selectedColumn]">
              <ul>
                <li *ngFor="let data of accData">
                  <span class="content-icon">
                    <fa-icon [icon]="iconByObjectType[data.type]"></fa-icon>
                  </span>
                  <span class="content-label">{{data.label}}</span>
                  <span class="content-value">{{data.value | number : '1.2-2'}}</span>
                </li>
              </ul>
            </aside>
          </ng-container>

        </div>
      </td>
    </tr>
  </ng-container>
    </tbody>
    <tfoot>
  <tr class="shadow-tr">
    <td [colSpan]="tableColumns.length + 1"></td>
  </tr>

  <tr *ngIf="allocationTotals">
    <th>FY</th>

    <td *ngFor="let column of tableColumns; let columnIndex = index">

      <!-- Budget total cell -->
      <ng-container *ngIf="column.id === manageTableBudgetColumnName.Budget">
        <budget-allocation-cell
          [ngClass]="{'display-inline-table': (allocationTotals[manageTableBudgetColumnName.Budget] < 0)}"
          [allocated]="allocationTotals[manageTableBudgetColumnName.Budget]"
          [spent]="null"
          [remaining]="isBudgetPrimary ? allocationTotals[manageTableBudgetColumnName.Available] : null"
          [hasRemainingBudget]="isBudgetPrimary"
          [disabled]="campaignIsClosed"
          [editable]="false"
          [showDifference]="isBudgetPrimary"
          [allowGestures]="false"
          [droppable]="false"
          [draggable]="false">
        </budget-allocation-cell>
      </ng-container>

      <!-- Forecast total cell -->
      <ng-container *ngIf="column.id === manageTableBudgetColumnName.Forecast">
        <budget-allocation-cell
          [ngClass]="{'display-inline-table': (allocationTotals[manageTableBudgetColumnName.Forecast] < 0)}"
          [allocated]="allocationTotals[manageTableBudgetColumnName.Forecast]"
          [spent]="null"
          [remaining]="isForecastPrimary ? allocationTotals[manageTableBudgetColumnName.Available] : null"
          [hasRemainingBudget]="isForecastPrimary"
          [disabled]="campaignIsClosed"
          [editable]="false"
          [showDifference]="isForecastPrimary"
          [allowGestures]="false"
          [droppable]="false"
          [draggable]="false">
        </budget-allocation-cell>
      </ng-container>

      <!-- Non-budget / non-forecast totals -->
      <ng-container *ngIf="column.id !== manageTableBudgetColumnName.Budget && column.id !== manageTableBudgetColumnName.Forecast">
        <ng-container *ngTemplateOutlet="clickableValue; context: {
          $implicit: allocationTotals[column.id],
          timeframeId: null,
          columnId: column.id
        }"></ng-container>
      </ng-container>

    </td>
  </tr>
</tfoot>

  </table>
</div>

<ng-template #clickableValue let-value let-timeframeId="timeframeId" let-columnId="columnId">
  <span class="default-value"
        [ngClass]="{ 'is-clickable': objectId && value }"
        (click)="value && onCellClick(timeframeId, columnId)">{{ value | absoluteNumber }}</span>
</ng-template>
